/*
 * Die beiden Pflichtangaben — Impressum und Datenschutz.
 *
 * ═══ Warum eine eigene Datei fuer zwei Konstanten ════════════════════════
 *
 * Aus demselben Grund wie `lib/auth-pfade.ts`: eine Adresse, die an mehr als
 * einer Stelle steht, laeuft auseinander. Der Bestand fuehrt dieselbe Datei
 * (`web/src/lib/rechtliches.ts`) und nennt dort als Konsumenten den Fuss des
 * RootLayouts UND `app/global-error.tsx` — die zweite Stelle rendert OHNE das
 * Layout, und ohne die geteilte Konstante haette sie ihre eigene Fassung der
 * URL bekommen.
 *
 * Diese SPA hat heute genau einen Konsumenten, den Fuss in `routes/__root.tsx`.
 * Die Datei steht trotzdem: `lib/server-pfade.test.ts` BEFRAGT sie (wie sie
 * `lib/auth-pfade.ts` befragt) und haelt damit jeden Verweis gegen die Liste
 * erlaubter Hosts, ohne dass jemand eine zweite Liste pflegt. Ein Literal im
 * JSX waere fuer diesen Waechter nur ein Fund, kein Vertrag.
 *
 * ═══ Warum EXTERN und nicht als eigene Seite ═════════════════════════════
 *
 * Die Texte werden auf linnenbecker.de gepflegt und gelten fuer das ganze
 * Haus. Eine Kopie hier waere eine zweite Fassung eines Rechtstextes — die
 * teuerste Sorte Doppelung, die es in diesem Repo gibt: sie veraltet still,
 * und ihr Fehler ist keine Anzeigefrage.
 *
 * ═══ Die Zusage, die daran haengt ════════════════════════════════════════
 *
 * § 5 DDG und Art. 13 DSGVO verlangen die Angaben LEICHT ERKENNBAR und
 * UNMITTELBAR ERREICHBAR. Der Bestand pinnt deshalb eigens, dass beide Links
 * schon OHNE Sitzung sichtbar sind (`e2e/specs/rechtliches-footer.spec.ts`)
 * — die Anmeldeseite ist die erste Seite, die ein Mensch sieht, und sie darf
 * die Pflichtangaben nicht hinter der Anmeldung verstecken.
 *
 * Der Waechter dazu ist `e2e/specs/rechtliches.spec.ts`; er faehrt den Fuss
 * ohne Sitzung UND mit an. Ohne einen benannten Waechter ueberlebt eine Zusage
 * dieser Art Jahre — das ist der Fund des zweiundzwanzigsten Durchgangs.
 */

/** Impressum, extern gepflegt (§ 5 DDG). */
export const IMPRESSUM_URL = "https://www.linnenbecker.de/Impressum/";

/** Datenschutzerklaerung, extern gepflegt (Art. 13 DSGVO). */
export const DATENSCHUTZ_URL = "https://www.linnenbecker.de/Datenschutz/";
